<orbit-dialog-header [title]="data.title" />

<div class="dialog-content">
  <form [formGroup]="data.form" class="tenant-form">
    <div class="form-group">
      <label for="name">{{ 'SETTINGS.GENERAL.TENANT_NAME' | translate }} *</label>
      <input
        id="name"
        type="text"
        formControlName="name"
        [placeholder]="'SETTINGS.GENERAL.TENANT_NAME_PLACEHOLDER' | translate">
      <div *ngIf="data.form.controls['name'].invalid && data.form.controls['name'].touched" class="error-message">
            <span *ngIf="data.form.controls['name'].errors?.['required']">
              {{ 'SETTINGS.GENERAL.NAME_REQUIRED' | translate }}
            </span>
        <span *ngIf="data.form.controls['name'].errors?.['minlength']">
              {{ 'SETTINGS.GENERAL.NAME_MIN_LENGTH' | translate }}
            </span>
        <span *ngIf="data.form.controls['name'].errors?.['maxlength']">
              {{ 'SETTINGS.GENERAL.NAME_MAX_LENGTH' | translate }}
            </span>
        <span *ngIf="data.form.controls['name'].errors?.['pattern']">
              {{ 'SETTINGS.GENERAL.NAME_PATTERN' | translate }}
            </span>
      </div>
    </div>
  </form>
</div>

<orbit-dialog-footer>
  <div class="right-addon" right-addon>
    <orbit-button
      [flat]="true"
      [disabled]="false"
      [label]="data.cancelLabel"
      (onClick)="closeDialog(false)">
    </orbit-button>
    <orbit-button
      [disabled]="data.form.invalid"
      [label]="data.confirmLabel"
      [icon]="saveIcon"
      (onClick)="closeDialog(true)">
    </orbit-button>
  </div>
</orbit-dialog-footer>

